<template>
    <div class="ag-input-wrapper" role="presentation" ref="flatpickr">
        <input @keydown.enter="stopEditing"
               type="text"
               ref="dateInput"
               placeholder="Select a date"
               class="form-control form-control-sm"
               data-input
               style="width: 100%;"/>
        <a class="input-button px-2 clickable" title="clear" data-clear>
            <i class="fa fa-times"></i>
        </a>
    </div>
</template>

<script>
import Vue from 'vue'
import flatpickr from 'flatpickr'
import moment from 'moment'
import {getFlatpikrConvertedDate} from '@/utils/date'

export default Vue.extend({
    name: 'AgGridCellEditorDate',
    data() {
        return {
            value: null
        }
    },
    methods: {
        isPopup() {
            return true
        },

        async onDateChanged(arr, dateStr) {
            this.value = dateStr
            await this.$nextTick()
            this.stopEditing()
        },

        stopEditing() {
            const {column, rowIndex} = this.params.api.getFocusedCell()
            this.params.api.setFocusedCell(rowIndex, column.getColId())
            this.params.api.stopEditing()
        },

        getValue() {
            return this.value && moment(getFlatpikrConvertedDate(this.value)).isValid()
                ? moment(getFlatpikrConvertedDate(this.value)).format('YYYY-MM-DD')
                : null
        },

        setDate(date) {
            this.value = date || null
            this.picker.setDate(date)
        }
    },
    async mounted() {
        this.picker = flatpickr(this.$refs['flatpickr'], {
            allowInput: true,
            dateFormat: 'Y-m-d',
            wrap: true,
            onChange: this.onDateChanged.bind(this)
        })
        this.setDate(this.params.value)
        this.picker.calendarContainer.classList.add('ag-custom-component-popup')
        await this.$nextTick()
        this.picker.open()
    }
})
</script>
